import { render, staticRenderFns } from "./Pill.vue?vue&type=template&id=2ee79be3"
import script from "./Pill.vue?vue&type=script&lang=js"
export * from "./Pill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports